document.querySelectorAll('a[href="#privacy-notice"]').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    UC_UI.showSecondLayer();
  });
});